var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTableMoreVerticalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33333 8.33334C9.33333 7.59696 8.73638 7 8 7C7.26362 7 6.66666 7.59696 6.66666 8.33334C6.66666 9.06972 7.26362 9.66667 8 9.66667C8.73638 9.66667 9.33333 9.06972 9.33333 8.33334Z",
    fill: "#4A4C4F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33333 4.66667C9.33333 3.93029 8.73638 3.33334 8 3.33334C7.26362 3.33334 6.66666 3.93029 6.66666 4.66667C6.66666 5.40305 7.26362 6 8 6C8.73638 6 9.33333 5.40305 9.33333 4.66667Z",
    fill: "#4A4C4F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33333 12C9.33333 11.2636 8.73638 10.6667 8 10.6667C7.26362 10.6667 6.66666 11.2636 6.66666 12C6.66666 12.7364 7.26362 13.3333 8 13.3333C8.73638 13.3333 9.33333 12.7364 9.33333 12Z",
    fill: "#4A4C4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableMoreVerticalIcon);
export default __webpack_public_path__ + "static/media/table-more-vertical-icon.e7e26ecce097f24ed961cbf9f5820831.svg";
export { ForwardRef as ReactComponent };